import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as attribute from './attribute'

export const DOC = gql`
  ${attribute.DOC}
  fragment FragmentDmsSnapshot on DmsSnapshot {
    id
    name
    description
    note
    terms {
      id
    }
    attributes {
      ...FragmentDmsAttribute
    }
    dimension {
      id
      name
      description
    }
  }
`

/**
 * Transformer for the {@link graphql.schema.FragmentDmsSnapshotFragment} to the
 * {@link ents.core.dms.models.Snapshot}.
 */
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsSnapshotFragment,
  ents.core.dms.models.Snapshot
>({
  attributes: graphql.transformers.OUT.list(attribute.TRANSFORMER, {
    onNullish: 'remove',
  }),
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Snapshot.Id.isId,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  note: transformers.PASS_THROUGH,
  // TODO: finish implementing
  terms: () => undefined,
})
